import { render, staticRenderFns } from "./SaveBiometricsModal.vue?vue&type=template&id=374490b9&scoped=true&"
import script from "./SaveBiometricsModal.vue?vue&type=script&lang=js&"
export * from "./SaveBiometricsModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveBiometricsModal.vue?vue&type=style&index=0&id=374490b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374490b9",
  null
  
)

export default component.exports